import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getSearchString } from 'utils/urlOperations';
import { shouldComponentRender } from 'components/ACL';
import * as NAVBAR from 'modules/styled/navbar';
import * as REPORTS_ACTIONS from 'actions/reports';
import * as FEEDBACKS_ACTIONS from 'actions/feedbacks';
import * as GALLERY_ACTIONS from 'actions/gallery';
import * as INSIGHTS_ACTIONS from 'actions/insights';
import * as FILTER_ACTIONS from 'actions/filter';

class NavMenu extends Component {
  constructor(props) {
    super(props);
    this.state = { search: props.history.location.search };
    this.checkPropsChanged = this.checkPropsChanged.bind(this);
    this.loadCounters = this.loadCounters.bind(this);
    this.closeReport = this.closeReport.bind(this);
  }

  componentDidUpdate(prevProps) {
    this.checkPropsChanged(prevProps);
  }

  checkPropsChanged(prevProps) {
    const {
      report, filters, history, loadFilters,
    } = this.props;
    const { report: prevReport, filters: prevFilters } = prevProps;
    const { search } = this.state;

    if (_.isEmpty(report)) {
      return;
    }

    const reportSelected = _.isEmpty(prevReport) && !_.isEmpty(report);
    const reportChanged = !_.isEqual(report.id, prevReport.id);
    const filtersChanged = (filters !== null && prevFilters !== null) && (
      !_.isEqual(filters, prevFilters)
    );
    const searchChanged = !_.isEqual(history.location.search, search);

    if (reportSelected || reportChanged || filtersChanged || searchChanged) {
      if (searchChanged) {
        this.setState({ search: history.location.search });
      }
      if (!_.isEmpty(report)) {
        this.loadCounters();
        loadFilters(report.id);
      }
    }
  }

  loadCounters() {
    const {
      selectedKey,
      history,
      loadFeedbacks,
      loadGallery,
      loadInsights,
    } = this.props;

    if (_.isEmpty(selectedKey)) {
      return;
    }

    const q = getSearchString(history, 'q');

    if (!history.location.pathname.match(/^\/feedbacks\/?$/)) {
      loadFeedbacks({ q, page: { number: 1, size: 0 } });
    }

    if (selectedKey !== 'gallery') {
      loadGallery({ q, page: { number: 1, size: 0 } });
    }

    if (selectedKey !== 'insights') {
      loadInsights({ page: { number: 1, size: 0 } });
    }
  }

  closeReport(event) {
    event.preventDefault();
    const {
      closeReport,
      history,
    } = this.props;

    closeReport().then(() => {
      history.push('/reports');
    });
  }

  render() {
    const {
      report,
      selectedKey,
      feedbacksCount,
      galleryCount,
      insightsCount,
    } = this.props;

    return (
      <NAVBAR.NavWrapper
        selectedKeys={[selectedKey]}
        mode="horizontal"
      >
        <NAVBAR.PrimaryItem key="reports">
          <NAVBAR.ItemContent>
            <Link to={`/reports${!_.isEmpty(report) ? `/${report.id}` : ''}`}>
              {!_.isEmpty(report) ? _.truncate(report.name, { length: 50 }) : 'Reports'}
            </Link>
            {!_.isEmpty(report) && <NAVBAR.CloseReport onClick={this.closeReport} />}
          </NAVBAR.ItemContent>
        </NAVBAR.PrimaryItem>
        {!_.isEmpty(report) && (
          <NAVBAR.NavItem key="feedbacks">
            <Link to="/feedbacks?view=list">
              <NAVBAR.ItemContent>
                Feedbacks
                <NAVBAR.Counter count={feedbacksCount} overflowCount={feedbacksCount + 1} />
              </NAVBAR.ItemContent>
            </Link>
          </NAVBAR.NavItem>
        )}
        {!_.isEmpty(report) && (
          <NAVBAR.NavItem key="gallery">
            <Link to="/gallery">
              <NAVBAR.ItemContent>
                Gallery
                <NAVBAR.Counter count={galleryCount} overflowCount={galleryCount + 1} />
              </NAVBAR.ItemContent>
            </Link>
          </NAVBAR.NavItem>
        )}
        {shouldComponentRender({ hiddenTo: ['guest'] }) && (
          <NAVBAR.NavItem key="exports">
            <Link to="/exports">Exports</Link>
          </NAVBAR.NavItem>
        )}
        {!_.isEmpty(report) && shouldComponentRender({ visibleTo: ['admin'] }) && (
          <NAVBAR.NavItem key="insights">
            <Link to="/insights">
              <NAVBAR.ItemContent>
                Insights
                <NAVBAR.Counter count={insightsCount} overflowCount={insightsCount + 1} />
              </NAVBAR.ItemContent>
            </Link>
          </NAVBAR.NavItem>
        )}
      </NAVBAR.NavWrapper>
    );
  }
}

NavMenu.defaultProps = {
  galleryCount: null,
  feedbacksCount: null,
  insightsCount: null,
};

NavMenu.propTypes = {
  selectedKey: PropTypes.string.isRequired,
  report: PropTypes.object.isRequired, // eslint-disable-line
  filters: PropTypes.object, // eslint-disable-line
  feedbacksCount: PropTypes.number,
  galleryCount: PropTypes.number,
  insightsCount: PropTypes.number,
  closeReport: PropTypes.func.isRequired,
  loadFeedbacks: PropTypes.func.isRequired, // eslint-disable-line
  loadGallery: PropTypes.func.isRequired, // eslint-disable-line
  loadFilters: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired, // eslint-disable-line
};

const mapStateToProps = (state) => ({
  report: state.reports.report,
  filters: state.filter.data,
  feedbacksCount: state.feedbacks.meta.records_count,
  galleryCount: state.gallery.meta.records_count,
  insightsCount: state.insights.meta?.records_count || 0,
});

const mapDispatchToProps = {
  closeReport: REPORTS_ACTIONS.closeReport,
  loadFeedbacks: FEEDBACKS_ACTIONS.load,
  loadGallery: GALLERY_ACTIONS.load,
  loadInsights: INSIGHTS_ACTIONS.load,
  loadFilters: FILTER_ACTIONS.loadFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavMenu));
